module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "plm_hd",
    attrs: {
      "id": "sgc-toc-level-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_serpref"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_abbrev"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("1 Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_2"
    }
  }, [_vm._v("Thesis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_3"
    }
  }, [_vm._v("Joseph in canonical context in pre-modern Christian literature")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_4"
    }
  }, [_vm._v("Modern scholarship on Joseph’s significance in Genesis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_5"
    }
  }, [_vm._v("The use of the Joseph narrative in later Scripture")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_6"
    }
  }, [_vm._v("Joseph as a type of Christ in modern scholarship")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PTOP_ch01#sigil_toc_id_7"
    }
  }, [_vm._v("Preview of the argument")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("2 Biblical theology and typology")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch02#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defining biblical theology")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch02#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defining typology")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("3 The Joseph story in Genesis’ ")]), _c('span', {
    staticClass: "bolditalic2"
  }, [_vm._v("tôlĕdôt")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v(" structure")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch03#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Function of the "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("tôlĕdôt")]), _vm._v(" formula: tracing God’s promise through each generation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch03#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("tôlĕdôt")]), _vm._v(" structure and the story of Joseph")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("4 Joseph and covenant: kingship")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introducing Joseph and Genesis 37 – 50")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph in biblical-theological perspective")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal seed: primeval types and promises")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal seed: Abrahamic types and promises")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph: Abraham’s royal seed")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch04#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and Judah: present and future royal seed")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("5 Joseph and covenant: seed")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch05#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘seed’ theme in Genesis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch05#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preservation and proliferation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch05#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seed conflict and sibling rivalry")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("6 Joseph and covenant: land and blessing")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The land theme in Genesis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Promised Land in the story of Joseph")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blessing in Genesis")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blessing in the Joseph story")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other possibly significant biblical-theological features of the Joseph story")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffering, glory and the promise-keeping God: synthesizing the major themes of the Joseph story")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch06#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implications for a canonical understanding of the Joseph narrative")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("7 Joseph in the Old Testament")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and the exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph in Psalm 105")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and Daniel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The exalted Jew in a foreign court")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch07#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implications for a canonical understanding of the Joseph narrative")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("8 Joseph in the New Testament")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch08#sigil_toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph in Acts 7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch08#sigil_toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph in Hebrews 11")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch08#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allusions to the Joseph story in the parable of the tenants")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch08#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implications for a canonical understanding of the Joseph narrative")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("9 Conclusion")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_bibliog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_idx_aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search terms for authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_idx_scr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search terms for Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PTOP_series",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titles in this series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214ff164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PTOP_contents.vue
// module id = 63
// module chunks = 0